export const groupComments = (comments = []) => {
    const topLevel = [];
    const repliesByParent = {};

    comments.forEach((comment) => {
        if (!comment?.parentId) {
            topLevel.push(comment);
            return;
        }

        if (!repliesByParent[comment.parentId]) {
            repliesByParent[comment.parentId] = [];
        }
        repliesByParent[comment.parentId].push(comment);
    });

    Object.values(repliesByParent).forEach((replies) => {
        replies.sort((left, right) => {
            const leftTime = new Date(left?.createdAt || 0).getTime();
            const rightTime = new Date(right?.createdAt || 0).getTime();
            return leftTime - rightTime;
        });
    });

    return { topLevel, repliesByParent };
};

export default groupComments;
